import { CButton, CCol, CForm, CFormGroup, CImg, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel, CRow, CSelect } from '@coreui/react'
import React from 'react'
import { RegisterCustomSelectPais } from './RegisterCustomSelect'
import { RegisterStepLeft } from './RegisterStepLeft'

export const RegisterStep0 = ({ DataForm, handleChange, onCancel, onSuccess }) => {
    return (
        <CRow>
            <RegisterStepLeft DataForm={DataForm} />
            <CCol xs="12" md="5">
                <div className="text-md-left ">
                    <h3 className="text-primary">
                        Informacion de la Cooperativa.
                    </h3>
                    <p>
                        Agradecemos completar la información solicitada de forma clara, precisa y verídica. Este formulario está dividido en dos secciones: Información de la Cooperativa e Información del Representante. Todos los campos marcados con asterisco (*) son obligatorios.
                    </p>
                    <p></p>
                </div>

                <div className="form-group " style={{ marginTop: 30 }}>

                    {[
                        {
                            id: 1,
                            name: 'Republica Dominicana'
                        },
                        {
                            id: 2,
                            name: 'Guatemala'
                        },
                        {
                            id: 3,
                            name: 'Honduras'
                        },
                        {
                            id: 100,
                            name: 'otros'
                        }
                    ].map((row, index) => {
                        return (
                            <RegisterCustomSelectPais
                                key={index}
                                id={row.id}
                                name="pais"
                                value={DataForm.pais}
                                label={row.name}
                                onChange={handleChange}


                            />
                        )
                    })}
                </div>
                <div
                    className="row justify-content-center"
                    style={{ flexFlow: "row", paddingTop: 200 }}
                >
                    <CButton
                        type="submit"
                        style={{ background: 'red', height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onCancel}
                    >
                        Cancelar
                    </CButton>
                    <CButton
                        type="submit"
                        color="primary"
                        style={{ height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        disabled={parseInt(DataForm.pais) === 0}
                        onClick={onSuccess}
                    >
                        Siguiente
                    </CButton>
                </div>
            </CCol>
        </CRow>
    )
}
